module.exports = __webpack_public_path__ + "static/img/double-check.e4b322a0.svg";